<script lang="ts" setup>
withDefaults(
  defineProps<{
    color?: string
    iconLeft?: string | null
    iconRight?: string | null
    isActive?: boolean
    isIndicator?: boolean
    indicatorValue?: number
    name?: string | null
  }>(),
  {
    color: '#202020',
    iconLeft: null,
    iconRight: null,
    isActive: false,
    isIndicator: false,
    indicatorValue: 0,
    name: null
  }
)
</script>

<template>
  <button
    class="relative flex items-center rounded-[16px] bg-white p-[10px] pr-3"
    :class="{ '!bg-main-green': isActive }"
  >
    <Indicator v-if="isIndicator" :value="indicatorValue" />

    <SvgIcon v-if="iconLeft" class="!size-5" :name="iconLeft" />

    <span v-if="name" class="mx-0.5 block text-sm">
      {{ name }}
    </span>

    <SvgIcon v-if="isActive" class="!size-5" name="outlined/delete" />
    <SvgIcon v-else-if="iconRight && !isActive" class="!size-5" :name="iconRight" />
  </button>
</template>
